module.exports = __webpack_public_path__ + "static/media/careem.0f991899.jpg";